export default __webpack_public_path__ + "img/idle_extend_slogan.80fac80e.png";